import { formatMoney } from './money-formatting.js';
import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';

const mobile = matchMedia('(max-width: 749px)');
const root = document.querySelector('[data-sk-pdp]');
const host = document.querySelector('fp-size-quantity');
if (root && host) {
  customElements.whenDefined('fp-size-quantity').then(() => {
  const details = host.closest('.product-details');
  const gallery = document.querySelector('media-gallery');
  const q = selector => root.querySelector(selector) || document.querySelector(selector);
  const picker = q('[data-sk-picker]'), purchase = q('[data-sk-purchase]'), custom = q('[data-sk-custom]');
  const chips = q('[data-sk-sizes]'), qty = q('#sk-pdp-quantity'), status = q('[data-sk-message]');
  const addButtons = [...document.querySelectorAll('[data-sk-add]')], buy = q('[data-sk-buy]');
  const shopPayForm = host.querySelector('.fp-size-quantity__actions .fp-shop-pay-form');
  const rows = [...host.querySelectorAll('[data-size-row]')];
  const placements = new Map();
  let selected = null, active = false, busy = false, appBlock = null, pendingCheckout = false, settlePurchase = null;
  const appSubmit = host.querySelector('[data-sk-easify-submit]');
  const originalUpdate = host.update.bind(host), originalAdd = host.addSelected.bind(host);
  const bagLink = q('[data-sk-bag]');
  const bagCount = document.createElement('span');
  bagCount.dataset.skBagCount = '';
  bagCount.hidden = true;
  bagCount.setAttribute('aria-hidden', 'true');
  bagCount.style.cssText = 'position:absolute;top:0;right:0;min-width:17px;height:17px;padding:0 4px;border-radius:10px;background:#c8a84e;color:#111;font:bold 10px/17px Arial;text-align:center;';
  bagLink.style.position = 'relative';
  bagLink.append(bagCount);
  const toast = document.createElement('div');
  toast.dataset.skAddedToast = '';
  toast.hidden = true;
  toast.style.cssText = 'position:fixed;z-index:30;left:20px;right:20px;bottom:calc(104px + env(safe-area-inset-bottom,0px));padding:12px 16px;border:1px solid #c8a84e;border-radius:6px;background:#101214;color:#fff;font:600 14px/1.4 Arial;text-align:center;box-shadow:0 4px 18px #0003;pointer-events:none;';
  // The existing inline live region announces success; the toast is visual only.
  toast.setAttribute('aria-hidden', 'true');
  root.append(toast);
  let toastTimer, cartRevision = 0;
  function updateBagCount(count) {
    if (!Number.isFinite(count)) return;
    bagCount.textContent = String(count);
    bagCount.hidden = count === 0;
    bagLink.setAttribute('aria-label', `Open shopping bag (${count} items)`);
  }
  function showAddedMessage() {
    status.style.color = '#24623b';
    status.textContent = '✓ Added to your bag';
    toast.textContent = '✓ Added to your bag';
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 3000);
  }
  async function refreshBagCount() {
    const revision = cartRevision;
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
      if (!response.ok) return;
      const cart = await response.json();
      if (revision === cartRevision) updateBagCount(cart.item_count);
    } catch { /* Cart interactions will retry the count update. */ }
  }
  let lastOptionsChange = 0;
  ['input','change','click'].forEach(name=>custom.addEventListener(name,()=>{lastOptionsChange=Date.now();}));
  const optionPriceNote=document.createElement('p');optionPriceNote.className='sk-pdp-option-price';optionPriceNote.hidden=true;custom.after(optionPriceNote);
  function syncOptionPrice(){
    const summary=appBlock?.querySelector('.po-priceSummary-root')?.textContent.trim() || '';
    if(optionPriceNote.textContent!==summary)optionPriceNote.textContent=summary;
    optionPriceNote.hidden=!summary;
    const base=q('[data-sk-total]');base.setAttribute('aria-label',summary?'Base product price; customization charges shown in the options':'Product price');
    const total=selected?host.totalPrice():Number(rows[0]?.dataset.price || 0);
    const text=(summary?'Base ':'')+money(total);if(base.textContent!==text)base.textContent=text;
  }
  const place = (node, parent, before = null) => {
    if (!node || !parent) return;
    if (!placements.has(node)) { const marker = document.createComment('sk-pdp-original'); node.before(marker); placements.set(node, marker); }
    parent.insertBefore(node, before);
  };
  const cleanupMorePaymentOptions = () => {
    document.querySelectorAll('more-payment-options-link').forEach(node => node.remove());
    document.querySelectorAll('.shopify-payment-button__more-options').forEach(node => node.remove());
  };
  const moveAssurancesBelowPaymentIcons = () => {
    const icons = purchase?.querySelector('.payment-icons');
    const assurances = document.querySelector('.fp-pdp-assurances');
    if (!icons || !purchase || !assurances) return;
    if (assurances.parentElement !== purchase) purchase.insertBefore(assurances, icons.nextSibling);
  };
  const paymentObserver = new MutationObserver(() => {
    cleanupMorePaymentOptions();
    moveAssurancesBelowPaymentIcons();
  });
  const money = cents => formatMoney(cents, host.dataset.moneyFormat || '${{amount}}', host.dataset.currency || window.Shopify?.currency?.active || 'USD');
  const variantLabel = row => row?.querySelector('.fp-size-quantity__label')?.textContent.trim() || '';
  function sync() {
    if (!active) return;
    if (selected && host.getQuantity(selected) === 0) selected = null;
    for (const chip of chips.children) chip.setAttribute('aria-pressed', String(chip.dataset.id === selected?.dataset.variantId));
    const total = selected ? host.totalPrice() : Number(rows[0]?.dataset.price || 0);
    q('[data-sk-total]').textContent = money(total);
    q('[data-sk-selection]').textContent = selected ? ' · ' + variantLabel(selected) : '';
    q('[data-sk-sticky-size]').textContent = selected ? variantLabel(selected) + ' · Qty ' + host.getQuantity(selected) : 'Select a size';
    const soldOut = rows.every(row => !row.querySelector('[data-quantity-input]'));
    for (const button of addButtons) {
      const sticky = button.closest('.sk-pdp-sticky');
      button.textContent = busy ? 'ADDING…' : soldOut ? 'SOLD OUT' : sticky && !selected ? 'SELECT A SIZE' : 'ADD TO CART';
      button.disabled = busy || soldOut;
    }
    buy.disabled = busy || soldOut;
    buy.textContent = busy ? 'Please wait…' : 'PAY IT NOW';
    const shopPayUnavailable = busy || soldOut || !selected;
    if (shopPayForm) {
      shopPayForm.classList.toggle('is-sk-disabled', shopPayUnavailable);
      shopPayForm.setAttribute('aria-disabled', String(shopPayUnavailable));
    }
    qty.disabled = !selected || busy;
    q('[data-sk-minus]').disabled = !selected || busy || host.getQuantity(selected) <= Number(selected.dataset.min || 1);
    q('[data-sk-plus]').disabled = !selected || busy || (selected.dataset.max && host.getQuantity(selected) >= Number(selected.dataset.max));
    if (selected) qty.value = String(host.getQuantity(selected));
    // Native payment forms stay in sync, even though mobile uses the validated add+checkout path.
    if (selected) host.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      const id = form.querySelector('input[name=id]');
      if (id && id.value !== selected.dataset.variantId) { id.value = selected.dataset.variantId; id.dispatchEvent(new Event('change', { bubbles: true })); }
      let quantity = form.querySelector('input[name=quantity]');
      if (!quantity) { quantity = document.createElement('input'); quantity.type = 'hidden'; quantity.name = 'quantity'; form.append(quantity); }
      quantity.value = String(host.getQuantity(selected));
    });
    syncOptionPrice();
  }
  host.update = function () { originalUpdate(); sync(); };
  function select(row) {
    if (busy || !row.querySelector('[data-quantity-input]')) return;
    selected = row;
    for (const r of rows) { const input = r.querySelector('[data-quantity-input]'); if (input) input.value = r === row ? String(Number(r.dataset.min || 1)) : '0'; }
    qty.min = row.dataset.min || '1'; qty.step = row.dataset.step || '1';
    if (row.dataset.max) qty.max = row.dataset.max; else qty.removeAttribute('max');
    status.textContent = '';
    host.update();
    const url = new URL(location.href); url.searchParams.set('variant', row.dataset.variantId); history.replaceState(history.state, '', url);
  }
  rows.forEach(row => {
    const button = [...chips.children].find(button => button.dataset.id === row.dataset.variantId);
    if (button) button.addEventListener('click', () => select(row));
  });
  function openCustom() {
    custom.classList.add('is-open');
    custom.querySelector('[data-sk-custom-toggle]')?.setAttribute('aria-expanded', 'true');
  }
  custom.querySelector('[data-sk-custom-toggle]')?.addEventListener('click', event => {
    const open = custom.classList.toggle('is-open');
    event.currentTarget.setAttribute('aria-expanded', String(open));
  });
  const setQuantity = value => {
    if (!selected || busy) return;
    const input = selected.querySelector('[data-quantity-input]');
    input.value = String(Math.max(Number(selected.dataset.min || 1), Number(value) || 1));
    host.normalizeInput(selected);
  };
  qty.addEventListener('change', () => setQuantity(qty.value));
  q('[data-sk-minus]').addEventListener('click', () => setQuantity(Number(qty.value) - Number(selected?.dataset.step || 1)));
  q('[data-sk-plus]').addEventListener('click', () => setQuantity(Number(qty.value) + Number(selected?.dataset.step || 1)));
  function invalidCustomization() {
    if (!appBlock) return null;
    return [...appBlock.querySelectorAll('input,select,textarea')].find(el => !el.disabled && el.type !== 'hidden' && el.getClientRects().length && !el.checkValidity());
  }
  function finishPurchase(message = '') { busy=false; if(message){status.style.color='';status.textContent=message;}sync();settlePurchase?.();settlePurchase=null; }
  appSubmit?.addEventListener('click', async () => {
    // Easify cancels this click when it takes ownership of an add-on purchase.
    // With no add-ons it lets the original theme handler run unchanged.
    await originalAdd(pendingCheckout);
    const error=host.querySelector('[data-size-message].is-error');
    finishPurchase(error?.textContent || '');
  });
  document.addEventListener('sk:pdp-app-added', async () => {
    try {
      const route=window.Shopify?.routes?.root || '/';
      const cartResponse=await fetch(route+'cart.js');if(!cartResponse.ok)throw Error('Item added. Please open your bag to review it.');
      const cart=await cartResponse.json();
      if(pendingCheckout){location.assign(route+'checkout');finishPurchase();return;}
      const rendered=await fetch(route+'?sections=cart-drawer-section');
      const sections=rendered.ok?await rendered.json():{};
      const deferred=CartLinesUpdateEvent.createPromise();
      host.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[],promise:deferred.promise}));
      deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'fp-size-quantity',sourceId:host.id,itemCount:cart.item_count,sections,didError:false}});
      addedMessage='✓ Added to your bag';
      if (!active) document.querySelector('theme-drawer#cart-drawer')?.open();
      finishPurchase();
    }catch(error){finishPurchase(error.message);}
  });
  host.addSelected = async function (checkout) {
    if (!active) return originalAdd(checkout);
    if (busy) return;
    status.style.color = '';
    if (!selected) {
      status.textContent = 'Please choose your size first.';
      picker.scrollIntoView({ block: 'center', behavior: 'auto' });
      chips.querySelector('button:not(:disabled)')?.focus({ preventScroll: true });
      return;
    }
    const invalid = invalidCustomization();
    if (invalid) { openCustom(); invalid.reportValidity(); invalid.focus(); return; }
    if(appBlock && appSubmit?.dataset.appReady!=='true'){openCustom();status.textContent='Customization is still loading. Please try again in a moment.';return;}
    status.textContent = ''; busy = true; pendingCheckout=checkout; sync();
    toast.hidden = true;
    clearTimeout(toastTimer);
    if(!appBlock){await originalAdd(checkout);finishPurchase(host.querySelector('[data-size-message].is-error')?.textContent || '');return;}
    // Easify publishes surcharge metadata with a 200ms debounce. Wait for the
    // user's last option edit to settle before its validated click is dispatched.
    while(Date.now()-lastOptionsChange<450)await new Promise(resolve=>setTimeout(resolve,100));
    await new Promise(resolve=>{
      settlePurchase=resolve;
      appSubmit.disabled=false;appSubmit.click();
      const timer=setTimeout(()=>{if(busy){openCustom();finishPurchase('Please check your options. If an item was already added, review your bag before trying again.');}},30000);
      const done=settlePurchase;settlePurchase=()=>{clearTimeout(timer);done?.();};
      // Validation failures do not run the app's after-add callback.
      setTimeout(()=>{if(busy&&!appSubmit.disabled&&[...appBlock.querySelectorAll('[class*="error"],[class*="Error"]')].some(el=>el.getClientRects().length&&el.textContent.trim())){openCustom();finishPurchase('Please complete the highlighted customization fields.');}},500);
    });
  };
  addButtons.forEach(button => button.addEventListener('click', () => host.addSelected(false)));
  buy.addEventListener('click', () => host.addSelected(true));
  document.querySelectorAll('[data-sk-guide]').forEach(button => button.addEventListener('click', () => details.querySelector('fp-size-guide [data-size-guide-open]')?.click()));
  const dialogs = [...document.querySelectorAll('dialog')];
  function openDialog(id, opener) {
    dialogs.forEach(d => { if (d.open) d.close(); });
    const dialog = document.getElementById(id);
    if (id === 'sk-pdp-saved') renderSaved();
    dialog.showModal();
    dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); }, { once: true });
  }
  document.querySelectorAll('[data-sk-open]').forEach(button => button.addEventListener('click', () => openDialog(button.dataset.skOpen, button)));
  dialogs.forEach(dialog => {
    dialog.querySelector('[data-sk-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target !== dialog) return; const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); });
  });
  q('[data-sk-bag]').addEventListener('click', e => { const drawer = document.querySelector('theme-drawer#cart-drawer'); if (drawer?.open) { e.preventDefault(); drawer.open(); } });
  // Local browser favourites: no account promises, tracking, or external writes.
  const savedKey = 'soccerkit:favourites:v1';
  const getSaved = () => { try { const v = JSON.parse(localStorage.getItem(savedKey) || '[]'); return Array.isArray(v) ? v.filter(p => typeof p.url === 'string' && /^\/products\/[a-zA-Z0-9-]+$/.test(p.url)).slice(0,50) : []; } catch { return []; } };
  const saveButton = q('[data-sk-save]');
  const updateSaved = () => { const saved = getSaved().some(p => p.id === root.dataset.productId); saveButton.setAttribute('aria-pressed', String(saved)); saveButton.setAttribute('aria-label', saved ? 'Remove from favourites' : 'Save this product'); };
  saveButton.addEventListener('click', () => {
    const items = getSaved(), index = items.findIndex(p => p.id === root.dataset.productId);
    if (index >= 0) items.splice(index,1); else items.unshift({ id:root.dataset.productId,title:root.dataset.title,url:root.dataset.productUrl,image:root.dataset.image });
    try { localStorage.setItem(savedKey, JSON.stringify(items.slice(0,50))); updateSaved(); q('[data-sk-save-status]').textContent = index >= 0 ? 'Removed from favourites.' : 'Saved on this browser.'; }
    catch { q('[data-sk-save-status]').textContent = 'Saving is unavailable in this browser.'; }
  });
  function renderSaved() {
    const list = q('[data-sk-saved-list]'); list.replaceChildren();
    const items = getSaved(); if (!items.length) { const p = document.createElement('p'); p.textContent = 'Tap the heart on a product to save it here.'; list.append(p); }
    items.forEach(item => {
      const card = document.createElement('div'); card.className = 'sk-pdp-saved-item';
      const a = document.createElement('a'); a.href = item.url; a.textContent = item.title || 'View product';
      const imageURL = new URL(item.image || '', location.origin);
      if (imageURL.protocol === 'https:' && (imageURL.hostname === location.hostname || imageURL.hostname === 'cdn.shopify.com')) { const img = document.createElement('img'); img.src=imageURL.href; img.alt='';img.loading='lazy';card.append(img); }
      const remove = document.createElement('button'); remove.type='button';remove.textContent='×';remove.setAttribute('aria-label','Remove '+(item.title || 'product'));
      remove.addEventListener('click',()=>{try{localStorage.setItem(savedKey,JSON.stringify(getSaved().filter(p=>p.id!==item.id)));renderSaved();updateSaved();}catch{}});
      card.append(a,remove);list.append(card);
    });
  }
  // Use the original gallery's controls, so swipe, variant media and zoom remain native.
  const thumbs = gallery?.querySelector('.sk-pdp-thumbs');
  const originalDots = [...(gallery?.querySelectorAll('.media-gallery__mobile-controls button') || [])];
  if (thumbs) [...(thumbs?.children || [])].forEach(button => {
    button.addEventListener('click', () => originalDots[Number(button.dataset.skSlide)]?.click());
  });
  const syncThumbs=()=>{[...thumbs.children].forEach((b,i)=>b.setAttribute('aria-pressed',String(originalDots[i]?.getAttribute('aria-selected')==='true')));};
  const thumbObserver=new MutationObserver(syncThumbs);originalDots.forEach(d=>thumbObserver.observe(d,{attributes:true,attributeFilter:['aria-selected']}));syncThumbs();
  function mountApp() {
    if (!active) return;
    const app = [...details.querySelectorAll('.shopify-app-block')].find(el => el.id.includes('easify_options_easify_product_options'));
    const optionsRoot = app?.querySelector('.easify-product-options');
    // Products without configured Easify fields still receive an empty app shell.
    // Treat that shell as no customization so normal variant purchases remain available.
    if (!optionsRoot || !optionsRoot.querySelector('input:not([type="hidden"]),select,textarea')) { custom.hidden=true; return; }
    appBlock=app;
    custom.hidden=false;
    openCustom();
    syncOptionPrice();
  }
  let addedMessage = '';
  function decorateCart() {
    if(!active)return;
    const inner=document.querySelector('#cart-drawer .cart-drawer__inner'),summary=inner?.querySelector('.cart-drawer__summary');
    if(!inner || !summary)return;
    if(addedMessage && !inner.querySelector('.sk-pdp-cart-note')){const note=document.createElement('p');note.className='sk-pdp-cart-note';note.setAttribute('role','status');note.textContent=addedMessage;inner.querySelector('.theme-drawer__header')?.after(note);}
    if(!summary.querySelector('.sk-pdp-cart-continue')){
      const button=document.createElement('button');button.type='button';button.className='sk-pdp-cart-continue';button.textContent='Continue shopping';button.addEventListener('click',()=>{document.querySelector('theme-drawer#cart-drawer')?.close();});summary.append(button);
      const brand=document.createElement('div');brand.className='sk-pdp-cart-brand';brand.textContent='SOCCERKIT';summary.append(brand);
    }
    const itemArea=inner.querySelector('.cart-drawer__items');
    const related=document.querySelector('.sk-pdp-recommendations .card-gallery');
    if(itemArea&&related&&!itemArea.querySelector('.sk-pdp-cart-pair')){
      const link=related.querySelector('a[href*="/products/"]'),image=related.querySelector('img');
      const price=related.closest('product-card')?.querySelector('.price')?.textContent.trim();
      if(link&&image){const box=document.createElement('div');box.className='sk-pdp-cart-pair';
        const heading=document.createElement('h3');heading.textContent='PAIR IT WITH';
        const a=document.createElement('a');a.href=link.href;
        const img=document.createElement('img');img.src=image.currentSrc||image.src;img.alt='';img.loading='lazy';
        const text=document.createElement('span');const name=document.createElement('span');name.textContent=link.getAttribute('aria-label')||image.alt;
        const amount=document.createElement('strong');amount.textContent=price||'';const action=document.createElement('small');action.textContent='View options →';text.append(name,amount,action);a.append(img,text);box.append(heading,a);itemArea.append(box);
      }
    }
  }
  document.addEventListener(StandardEvents.cartLinesUpdate,event=>{
    if(!active)return;
    event.promise?.then(({detail})=>{
      if (!detail?.didError) {
        cartRevision += 1;
        if (Array.isArray(detail?.items)) updateBagCount(detail.items.reduce((sum,item)=>sum+item.quantity,0));
        else refreshBagCount();
      }
      if(event.action==='add' && !detail?.didError){
        addedMessage='✓ Added to your bag';
        if (active && !pendingCheckout) showAddedMessage();
      } else addedMessage='';
      decorateCart();
    }).catch(()=>{});
  });
  const cartObserver=new MutationObserver(decorateCart);
  const cartWrapper=document.querySelector('#shopify-section-cart-drawer-section');if(cartWrapper)cartObserver.observe(cartWrapper,{subtree:true,childList:true});
  const appObserver=new MutationObserver(mountApp);
  function activate() {
    if(active || !mobile.matches || !details || !gallery)return;
    active=true;
    if(shopPayForm)place(shopPayForm,purchase,purchase.querySelector('[data-sk-add]')?.nextSibling || purchase.firstElementChild);
    cleanupMorePaymentOptions();
    moveAssurancesBelowPaymentIcons();
    paymentObserver.observe(purchase,{childList:true,subtree:true});
    const recommendations=document.querySelector('product-recommendations[data-intent=related]')?.closest('.shopify-section');
    if(recommendations)recommendations.classList.add('sk-pdp-recommendations');
    const reviews=document.querySelector('.jdgm-review-widget')?.closest('.shopify-section');
    if(reviews){reviews.classList.add('sk-pdp-reviews');if(recommendations)place(recommendations,reviews.parentNode,reviews);}
    mountApp();appObserver.observe(details,{childList:true,subtree:true});
    document.body.classList.add('sk-pdp-ready');
    status.textContent = '';
    const requested=new URL(location.href).searchParams.get('variant');
    const preselected=rows.find(r=>r.dataset.variantId===requested && r.querySelector('[data-quantity-input]'));
    if(preselected)select(preselected);else if(rows.length===1 && rows[0].querySelector('[data-quantity-input]'))select(rows[0]);else sync();
    updateSaved();decorateCart();
    refreshBagCount();
  }
  function deactivate(){
    if(!active)return;active=false;appObserver.disconnect();dialogs.forEach(d=>{if(d.open)d.close();});
    paymentObserver.disconnect();
    [...placements].reverse().forEach(([node,marker])=>{if(marker.parentNode)marker.parentNode.insertBefore(node,marker.nextSibling);});
    document.body.classList.remove('sk-pdp-ready');
    toast.hidden = true;
    clearTimeout(toastTimer);
    document.querySelectorAll('[data-sk-original]').forEach(el=>{el.textContent=el.dataset.skOriginal;delete el.dataset.skOriginal;});
  }
  mobile.addEventListener('change',()=>mobile.matches?activate():deactivate());
  activate();
  });
}
